export const LocalStorageKeys = {
    THEME: 'theme',
};
